import type {FilterProps} from './index-new';

import * as React from 'react';
import useI18n from 'src/hooks/useI18n';
import moment from 'moment';

import {formatPlural} from 'src/utils/intl';

import {FilterDropdown} from './common';
import DateRange from 'src/components/analytics/date-range';
import {AnalyticsService} from 'src/analytics';

import css from './index.css';


export default function TimeFrameFilter({
  query,
  minDate,
  defaultTimeAgo,
  direction,
}: FilterProps) {
  const {labelI18nInstance} = useI18n();
  const t = labelI18nInstance.t;
  return (
    <FilterDropdown
      text={humanTimeframeQuery(query, defaultTimeAgo, t)}
      header={t('timeframe', 'timeframe')}
      solid
      direction={direction}
    >
      <DateRange
        defaultTimeAgo={defaultTimeAgo}
        className={css.dateRange}
        minDate={minDate}
      />
    </FilterDropdown>
  );
}

const humanTimeframeQuery = (
  query: any,
  defaultTimeAgo: undefined | string,
  t: any,
) => {
  if (
    !query.start_date &&
    !query.end_date &&
    query.time_ago === undefined &&
    defaultTimeAgo
  ) {
    query.time_ago = defaultTimeAgo;
  }

  if (query.time_ago !== undefined) {
    const timeAgo = JSON.parse(query.time_ago).days;
    if (timeAgo !== undefined) {
      if (timeAgo === 1) {
        return t('Current_Day', 'Current Day');
      }
      return `${t('Last', 'Last')} ${timeAgo} ${formatPlural(
        timeAgo,
        t('day', 'day'),
        t('days', 'days'),
      )}`;
    }
  }
  if (query.start_date && query.end_date) {
    try {
      AnalyticsService.track('time_frame', {
        day: getTwoDateDiff(query.start_date, query.end_date),
      });
    } catch (error: any) {}
    return t('Custom_Date_Range', 'Custom Date Range');
  }
  if (!query.start_date && !query.end_date && !query.time_ago) {
    return t('Last_90_days', 'Last 90 days');
  }
  return t('Timeframe', 'Timeframe');
};

const getTwoDateDiff = (startDate: string, endDate: string) => {
  const start = moment(startDate);
  const end = moment(endDate);
  return end.diff(start, 'days');
};
